<template>
    <div>
        <div class="d-flex flex-column mb-1" v-if="autorizacao && autorizacao.status_solicitacao">
            <a href="#" @click.prevent="ver_autorizacao ()" class="badge" :class="'badge-' + autorizacao.status_solicitacao.color">
                S{{ autorizacao.id_solicitacao_autorizacao }} / {{ autorizacao.status_solicitacao.msg }}
            </a>
        </div>

        <div class="modal fade" id="verAutorizacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Autorização</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="autorizacao_consulta">
                            <div class="alert d-flex justify-content-between mb-3 px-2" :class="'alert-' + autorizacao_consulta.status_solicitacao.color">
                                <div class="lead">S{{ autorizacao_consulta.id_solicitacao_autorizacao }}</div>
                                <div>{{ autorizacao_consulta.nome_paciente }}</div>
                                <div>{{ autorizacao_consulta.status_solicitacao.msg }}</div>
                            </div>

                            <table class="table">
                                <tr :class="'table-' + traduzir_status_autorizacao(autorizacao_consulta.in_status).color">
                                    <td>{{ autorizacao_consulta.procedimento.search }}</td>
                                    <td class="text-right">{{ traduzir_status_autorizacao(autorizacao_consulta.in_status).msg }}
                                        <div v-if="autorizacao_consulta.st_codigo_autorizacao" class="small text-muted">
                                            <div>Senha: {{ autorizacao_consulta.st_codigo_autorizacao }}</div>
                                            <div v-if="autorizacao_consulta.dt_valid_termino">Valid.: {{ $util.getFormatDate(autorizacao_consulta.dt_valid_termino) }}</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-for="(outro, iox) in autorizacao_consulta.js_secundarios" :key="iox"
                                    :class="'table-' + traduzir_status_autorizacao(outro.in_status).color">
                                    <td>{{ outro.search }}</td>
                                    <td class="text-right">
                                        {{ traduzir_status_autorizacao(outro.in_status).msg }}
                                        <div v-if="outro.st_codigo_autorizacao" class="small text-muted">
                                            <div>Senha: {{ outro.st_codigo_autorizacao }}</div>
                                            <div v-if="outro.dt_valid_termino">Valid.: {{ $util.getFormatDate(outro.dt_valid_termino) }}</div>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <!-- Marcações / Atendimentos / Guias -->
                            <ul class="list-group" v-if="autorizacao_consulta.marcacoes && autorizacao_consulta.marcacoes.length">
                                <li class="list-group-item" v-for="(sessao, isx) in autorizacao_consulta.marcacoes" :key="isx">
                                    <div>
                                        <span v-if="sessao.id_atendimento">
                                            <i class="fa fa-check-circle text-success mr-2" aria-hidden="true" title="Atendimento Realizado"></i>
                                        </span>
                                        <span v-else>
                                            <i class="fas fa-circle text-secondary mr-2" aria-hidden="true" title="Agendado"></i>
                                        </span>
                                        {{ $util.getFormatDate(sessao.dt_inicio) }}
                                        {{ sessao.dt_inicio.substr(11,5) }}
                                        <span class="ml-3 text-muted">
                                            {{ getHumanDay(sessao.dt_inicio) }}
                                        </span>
                                        <span class="ml-3" title="Número do Atendimento." v-if="sessao.id_atendimento">
                                            <a href="#" @click.prevent="abrir_atendimento({ marcacao: sessao })" class="card-link">
                                                #{{ sessao.id_atendimento }}
                                            </a>

                                            <span v-if="sessao.atendimento && sessao.atendimento.guias && sessao.atendimento.guias.length" class="ml-2">
                                                <a href="#" @click.prevent="ver_guia(guia)" v-for="(guia, igx) in sessao.atendimento.guias" :key="igx">
                                                    <span class="badge mr-1" :class="'badge-' + guia.status_color" :title="guia.status_guia">
                                                        {{ guia.ch_status }}
                                                    </span>
                                                </a>
                                            </span>
                                        </span>
                                        <div v-if="autorizacao && sessao.id_medico != autorizacao.id_medico && sessao.medico">
                                            <span class="badge badge-secondary">
                                                {{ sessao.medico.st_nome_exibicao }}
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <button type="button" class="btn btn-primary" @click="ir_para()">Abrir</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';

export default { 
    data() {
        return {
            autorizacao_consulta: null, 
        };
    },

    props: [
        'autorizacao'
    ],

    methods: {
        fechar() { 
            this.autorizacao_consulta = null; 
            $('#verAutorizacaoModal').modal('hide');
        },

        ir_para() { 
            if ( !this.autorizacao_consulta ) { 
                return;
            }

            $('.modal').modal('hide');

            this.$router.push({ 
                name: 'solic-autoriz',
                params: { 
                    aba: 'lista', 
                    id: this.autorizacao_consulta.id_solicitacao_autorizacao,
                },
            });
        },

        getHumanDay(date) {
            return moment(date, "YYYY-MM-DD").format("dddd");
        },
        
        traduzir_status_autorizacao(status) { 
            switch (status) {
                case 0: return { msg: 'Aberto', color: 'primary' };
                case 1: return { msg: 'Autorizado', color: 'success' };
                case 2: return { msg: 'Em análise', color: 'info' };
                case 3: return { msg: 'Negado', color: 'danger' };
                case 4: return { msg: 'Autorizado Parcialmente', color: 'warning' };
                case 5: return { msg: 'Cancelado', color: 'Secondary' };
                case 6: return { msg: 'Enviado', color: 'dark' };
                case 7: return { msg: 'Negado Parcialmente', color: 'danger' };
                case 8: return { msg: 'Cancelado Parcialmente', color: 'secondary' };
                default: return { msg: status, color: 'light' };
            }
        },

        abrir (autorizacao) { 
            this.autorizacao_consulta = null; 
            $('#verAutorizacaoModal').modal('show');

            this.$util.load(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'show',
                parms: { 
                    id: autorizacao.id_solicitacao_autorizacao,
                    para_agendar: true, 
                },
                loadTo: res => { 
                    this.autorizacao_consulta = res;
                },
            });
        },

        ver_autorizacao () { 
            if ( !this.autorizacao ) { 
                return;
            }

            this.abrir(this.autorizacao);

            /*
            this.autorizacao_consulta = null; 
            $('#verAutorizacaoModal').modal('show');

            this.$util.load(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'show',
                parms: { 
                    id: this.autorizacao.id_solicitacao_autorizacao,
                    para_agendar: true, 
                },
                loadTo: res => { 
                    this.autorizacao_consulta = res;
                },
            });
            */

        },

    },

}
</script>